import Btn from "../utils/btn";

const func = $target => {

    var checkboxes = document.querySelectorAll('input.subOption'),
        $timezoneCheckBox = document.querySelectorAll('input.timezone-checkbox-group'),
        $btn = new Btn($target.find('button[type="submit"]')),
        checkall = document.getElementById('lithiumDisilicate');

    for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].onclick = function () {
            var checkedCount = document.querySelectorAll('input.subOption:checked').length;

            checkall.checked = checkedCount > 0;

            checkall.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length;
        }
    }

    checkall.onclick = function () {
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = this.checked;
        }
    }

    for (var k=0;k<$timezoneCheckBox.length;k++){
        $timezoneCheckBox[k].onclick = function () {
          var timezone_error = $('.timezone-checkbox-error');
            if (this.checked){
                timezone_error.hide();
                $btn.enable()
            }
        }
    }

    $(".form-control-file").change(function() {
        if ($('.form-control-file')[0].files.length !== 0) {
            $("[name ='makeupSuggestion']").removeAttr('required')
        }
    })

    $target.on('submit', function(e) {
        var timezone_error = $('.timezone-checkbox-error'),
            timezone_checked = $("[name='timezone[]']:checked").length;

        if ((timezone_checked == 0)){
            timezone_error.show();
            return false;
        }if(timezone_checked == 0) {
            timezone_error.show();
            return false;
        }
    })
}
export default func;